/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetorchestratorv2Column } from '../models/Targetorchestratorv2Column';
import { Targetorchestratorv2FileType } from '../models/Targetorchestratorv2FileType';
import { HttpFile } from '../http/http';

/**
* The info about the source file being uploaded to create a Target and requote a job.
*/
export class V2ReplaceFileMetaData {
    /**
    * The name of the source file.
    */
    'filename': string;
    /**
    * Id of the org to which this target belongs
    */
    'orgId'?: string;
    'fileType'?: Targetorchestratorv2FileType;
    /**
    * Whether the file has a header or not.
    */
    'hasHeader'?: boolean;
    /**
    * An array of Column objects that define what each column in the file contains.
    */
    'columns': Array<Targetorchestratorv2Column>;
    'targetId'?: string;
    /**
    * IDs of the audiences to re generate with the new file.
    */
    'audienceIds'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "filename",
            "baseName": "filename",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "fileType",
            "baseName": "file_type",
            "type": "Targetorchestratorv2FileType",
            "format": ""
        },
        {
            "name": "hasHeader",
            "baseName": "has_header",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<Targetorchestratorv2Column>",
            "format": ""
        },
        {
            "name": "targetId",
            "baseName": "target_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "audienceIds",
            "baseName": "audience_ids",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V2ReplaceFileMetaData.attributeTypeMap;
    }

    public constructor() {
    }
}

